import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RepresentativeService {

constructor(private http:HttpClient) { }

GetRecord():Observable<Array<Customer_List_Interface>>{
  return this.http.get(environment.BaseUrl+ "Daro/Representative").pipe(
    map(data=>{
      return data as Array<Customer_List_Interface>
    })
  )
}

GetSingle(id:number):Observable<User_Interface>{
  return this.http.get(environment.BaseUrl+ "Daro/Representative/GetSingle?id="+id).pipe(
    map(data=>{
      return data as User_Interface
    })
  )
}

GetSubusername():Observable<any>{
  return this.http.get(environment.BaseUrl+ "Daro/Representative/GetSubusername").pipe(
    map(data=>{
      return data as any
    })
  )
}

DeleteRepresentative(id:number):Observable<User_Interface>{

  return this.http.get(environment.BaseUrl + "Daro/Representative/Delete?id="+id).pipe(
    map(data=>{
      return data as User_Interface
    })
  )

}

AddUser(model: User_Interface,ListMenu:Array<number>):Observable<User_Interface>{
  const headers = new HttpHeaders().set('content-type', 'application/json');


  var modelCustomer = {
    id:model.id,
    username:model.username,
    password:model.password,
    type:model.type,
    create_ip: '',
    fname:model.fname,
    lname:model.lname,
    phone:model.phone,
    del:false,
    subdate:null
  }

  var body={
    ListMenu:ListMenu,
    model:modelCustomer,
  }


    return this.http.post(environment.BaseUrl + "Daro/Representative/Add",body,{headers}).pipe(
      map(data=>{
        return data as User_Interface
      })
    )

}


}
